import * as DESIGN_SYSTEM_COLORS from "@streeteasy/design-system/colors";

const colors = {
  accent1: "#F1A728",
  accent2: "#72D9EC",
  errorRed: "#ED432F",
  footerGrey: "#272D39",
  foxGrey: "#CDCDCD",
  frostedGlass: "#E6F8FE",
  goatGrey: "#A1A1A1",
  highlightAvocado: "#E0E572",
  highlightDove: "#B5C8C9",
  ink: "#032765",
  koalaGrey: "#8C8C8C",
  mouseGrey: "#F5F5F5",
  primary: "#1876DB",
  primaryTouched: "#135EAF",
  pureBlack: "#000000",
  pureWhite: "#FFFFFF",
  rabbitGrey: "#E6E6E6",
  secondary: "#D3F4FF",
  whaleGrey: "#1A1F2C",
  wolfGrey: "#62646A",
  textSecondary: "#62646A"
};

/**
 * The following colors are being deprecated as part of a brand refresh.
 * We are temporarily aliasing deprecated colors to the value of their
 * replacements. Over time, we will replace references to these variables throughout
 * SE and react-ui-components.
 */

/**
 * @deprecated replaced by primaryTouched
 */
colors.brightBlue = colors.primaryTouched;

/**
 * @deprecated replaced by primary
 */
colors.classicBlue = colors.primary;

/**
 * @deprecated replaced by secondary
 */
colors.glass = colors.secondary;

/**
 * @deprecated replaced by accent2
 */
colors.highlightTeal = colors.accent2;

/**
 * @deprecated please use "@streeteasy/design-system/colors" instead
 */
export default { ...colors, ...DESIGN_SYSTEM_COLORS };
